import Date                        from "../../../domain/fundamentals/date/Date";
import Time                        from "../../../domain/fundamentals/date/Time";
import TimePeriod                  from "../../../domain/fundamentals/date/TimePeriod";
import Reservation                 from "../../../domain/reservation/Reservation";
import ReservationDetail           from "../../../domain/reservation/ReservationDetail";
import ReservationId               from "../../../domain/reservation/ReservationId";
import { ReservationResponseType } from "../../api/reservation/ReservationResponseType";
import { toCustomer }              from "../customer";
import { toFacility }              from "../facility";
import { toStaff }                 from "../staff";

export const toReservation = (source: ReservationResponseType): Reservation => new Reservation(
  new ReservationId(source.id),
  new ReservationDetail(
    Date.ofText(source.detail.date),
    new TimePeriod(
      Time.ofText(source.detail.from),
      Time.ofText(source.detail.to),
    ),
  ),
  toCustomer(source.customer),
  toStaff(source.staff),
  toFacility(source.facility),
);
